import { useLanguage } from '@/context/LanguageContext';
import { useLocation } from 'react-router-dom';
import { Globe } from 'lucide-react';

const TOP_LEFT_PATHS = ['/', '/portal', '/staff-login'];

const LanguageSwitcher = () => {
  const { language, toggleLanguage } = useLanguage();
  const { pathname } = useLocation();
  // Inside admin/staff screens, keep it out of the way of the sidebar and headers
  const position = TOP_LEFT_PATHS.includes(pathname) || pathname.startsWith('/invite') ? 'top-20 left-6' : 'bottom-4 right-4';

  return (
    <button
      onClick={toggleLanguage}
      data-testid="language-switcher"
      className={`fixed ${position} z-50 flex items-center gap-2 px-4 py-2 bg-[#121212]/90 border border-[#39FF14]/50 rounded-full shadow-lg hover:border-[#39FF14] hover:bg-[#1a1a1a] transition-colors duration-300 backdrop-blur-sm`}
      aria-label="Toggle language"
    >
      <Globe className="w-4 h-4 text-[#39FF14]" />
      <span className="font-bold text-white text-sm">
        {language === 'en' ? '日本語' : 'EN'}
      </span>
    </button>
  );
};

export default LanguageSwitcher;
